export default __webpack_public_path__ + "static/media/sexo.151515a6.svg";